import * as userBusiness from "../business/user"
import * as luckydrawBusiness from "../business/luckydraw"
import localStorage from "../../common/utils/localStorage"
import { assign, actions, send, forwardTo, spawn } from "xstate"
import reportActions from "./reportActions"
import * as url from "../../common/utils/url"
import * as inGameApi from "../../common/utils/inGame"
import * as R from "ramda"
const { pure } = actions
import { createLuckLotteryMachine } from "./machines/luck_lottery"
export default {
  ...reportActions,
  launchOpenlink: (context, event) => {
    location.href = event.data.info.openlink
  },
  redirect: (context, event) => {
    location.href = event.url
  },
  jumpToFightGameSence: context => {
    if (context.userAgent.msdk) {
      inGameApi.jumpGameSence(4)
    }
  },
  jumpToRechargeScene: context => {
    if (context.userAgent.msdk) {
      inGameApi.jumpGameSence(2)
    }
  },
  setLoginState: assign({
    loginState: (context, event) => {
      window.aegis.setConfig({
        uin: event.data.openid
      })
      return {
        openid: event.data.openid,
        openkey: event.data.openkey,
        session_id: event.data.session_id,
        session_type: event.data.session_type,
        wx_appid: event.data.wx_appid || "",
        accountType: event.data.accountType
      }
    },
    userInfo: (context, event) => {
      return {
        avatar: event.data.avatar,
        nickname: event.data.nickname
      }
    }
  }),
  setUserInfoFromTaskInfo: assign({
    userInfo: (context, event) => {
      let userInfo
      if (event.data.nick_img) {
        const info = decodeURIComponent(event.data.nick_img).split("&")
        const nickname = decodeURIComponent(info[0].split("=")[1])
        const avatar = decodeURIComponent(info[1].split("=")[1])
        if (avatar && nickname) {
          userInfo = {
            avatar,
            nickname
          }
        } else {
          userInfo = context.userInfo
        }
      } else if (context.userInfo?.avatar) {
        userInfo = context.userInfo
      }
      return userInfo
    }
  }),
  setUserInfoInGame: assign({
    userInfo: (context, event) => event.data
  }),
  setTasks: assign({
    tasks: (context, event) => {
      const map = context.selectedMap
      return {
        ...context.tasks,
        [map]: event.data
      }
    }
  }),
  setSelectedMap: assign({
    selectedMap: (context, event) => event.level
  }),
  switchMap: assign({
    taskInfo: (context, event) => {
      const info = context.tasks[event.level]
      return info
    }
  }),
  setTaskInfo: assign({
    taskInfo: (context, event) => event.data
  }),
  setZoneList: assign({
    zoneList: (context, event) => event.data
  }),
  persistUserZoneRole: context => {
    localStorage.set(
      `wzry_activity_${context.gameConfig.offerId}_${context.loginState.openid}_${context.userAgent.weixin ? "wx" : "qq"}`,
      JSON.stringify(context.selectedZone)
    ) //把用户选过的大区存起来
  },
  setSelectedZoneFromList: assign({
    selectedZone: context => context.zoneList.find(item => item.zone_id == context.selectedZoneId)
  }),
  setZoneIdFromOutside: assign({
    selectedZoneId: (context, event) => event.data
  }),
  changeZoneIdFromList: assign({
    selectedZoneId: (context, event) => event.zone_id
  }),
  setSelectedRole: assign({
    selectedRole: (context, event) => event.data.roleInfo
  }),
  cancelRole: assign({ selectedRole: () => "" }), //清空选中角色
  fetchRoleToast: assign({
    toastMsg: (context, event) => event.data.message || event.data.msg
  }),
  registerTaskError: assign({
    toastMsg: "系统异常，请稍后再试！"
  }),
  setPartitionInfoFromCGIDATA: assign((context, event) => {
    const partitionInfo = decodeURIComponent(event.data.cgi_data)
    return {
      taskInfo: event.data,
      selectedZoneId: url.getParam("partition", partitionInfo),
      partitionInfo: {
        game_platform_id: url.getParam("plat_id", partitionInfo),
        area: url.getParam("area", partitionInfo),
        partition: url.getParam("partition", partitionInfo)
      }
    }
  }),
  setPartitionInfoFromRoleInfo: assign({
    partitionInfo: (context, event) => {
      return {
        game_platform_id: event.data.partitionInfo.platid,
        area: event.data.partitionInfo.area,
        partition: event.data.partitionInfo.partition
      }
    }
  }),
  checkZoneOrSkip: pure(context => {
    let plat
    if (context.userAgent.iOS) {
      plat = 0
    } else if (context.userAgent.android) {
      plat = 1
    }
    if (plat != context.partitionInfo.game_platform_id) {
      //如果iOS用户在iOS分区注册的任务，然后用安卓手机登陆
      return send("PLATFORM_NOT_MATCH")
    } else {
      return context.selectedRole && context.selectedRole.id ? send("SKIP") : send("CHECK_ZONE") //根据条件触发事件，如果已经有角色了就不再进行大区角色查询
    }
  }),
  setUnusedCoupon: assign({
    unusedCoupon: (context, event) => {
      const unusedCoupon = {
        ...context.unusedCoupon,
        [context.selectedMap]: event.data
      }
      return unusedCoupon
    }
  }),
  updateUltimateUnusedCoupon: assign({
    unusedCoupon: (context, event) => {
      const ultimateGroupid = context.gameConfig.drawGroupid[context.selectedMap].find(item => item.rank == 7).groupid
      const unusedCoupon = {
        ...context.unusedCoupon,
        [context.selectedMap]: {
          ...context.unusedCoupon?.[context.selectedMap],
          [ultimateGroupid]: event.data[ultimateGroupid]
        }
      }
      return unusedCoupon
    }
  }),
  consumeUnusedCoupon: assign({
    unusedCoupon: context => {
      const usedGroupid = context.gameConfig.drawGroupid[context.selectedMap].find(item => item.rank == context.selectedPresentRank).groupid
      const codeList = R.drop(1, context?.unusedCoupon?.[usedGroupid] || [])
      const unusedCoupon = {
        ...context.unusedCoupon,
        [context.selectedMap]: { ...context.unusedCoupon?.[context.selectedMap], [usedGroupid]: codeList }
      }
      return unusedCoupon
    }
  }),
  //设置用户选中抽奖档位
  setSelectedPresentRank: assign({
    selectedPresentRank: (context, event) => {
      return event.present_rank
    }
  }),
  //删除用户选中档位
  delSelectedPresentRank: assign({
    selectedPresentRank: () => ""
  }),

  //设置用户能领取的任务奖励档位
  setAvailableOpenPresentRank: assign({
    availableReceivedRank: context => {
      return luckydrawBusiness.getAvailableOpenPresentRank({
        rank: context.selectedPresentRank,
        total_score: context.taskInfo.total_score,
        present_rank: context.taskInfo.present_rank
      })
    }
  }),
  drawAfterPay: send(context => {
    let present_rank = +context.taskInfo.total_score % 6
    if (present_rank === 0) {
      present_rank = 6
    }
    return {
      type: "CLICK_PRESENT",
      present_rank
    }
  }),
  sendPrizeList: send(context => ({
    type: "FETCH_PRIZE_LIST",
    rank: context.selectedPresentRank
  })),
  //发送开始抽奖的事件
  sendStartDraw: send(context => ({
    type: "OPEN_BOX",
    data: context.selectedPresentRank
  })),
  forwardPrizeList: forwardTo("getPrizeList"),
  //更新任务档位完成后的奖励领取
  updatePresentRank: assign(context => {
    let present_rank = context.taskInfo.present_rank
    const receivedRank = context.availableReceivedRank.shift() //这个档位领取成功后，把他出队
    present_rank = `${present_rank},${receivedRank}`
    context.taskInfo.present_rank = present_rank

    context.tasks[context.selectedMap] = context.taskInfo

    return {
      taskInfo: context.taskInfo,
      tasks: context.tasks
    }
  }),
  updateBatchPresentRank: assign(context => {
    const score = context.taskInfo.total_score
    context.taskInfo.present_rank = R.range(1, +score + 1).join(",")
    context.tasks[context.selectedMap] = context.taskInfo

    return {
      taskInfo: context.taskInfo,
      tasks: context.tasks
    }
  }),
  setCouponNum: assign({
    couponNum: (context, event) => event.data.length
  }),
  //批量抽奖创建actor
  batchDrawActor: assign({
    luckLottery: (context, event) => {
      const luckLottery = {}
      const sixBoxGroupid = context.gameConfig.drawGroupid[context.selectedMap].filter(item => item.rank <= 6).map(item => item.groupid)
      for (let key of Object.keys(R.pick(sixBoxGroupid, event.data))) {
        const derivedContext = R.pick(["sandbox", "loginState", "partitionInfo", "gameConfig"], context)
        if (!context?.luckLottery?.[key]) {
          luckLottery[key] = spawn(
            createLuckLotteryMachine({
              groupid: key,
              codeId: event.data[key]?.[0]?.code_id,
              context: derivedContext
            }),
            key
          )
        } else {
          luckLottery[key] = context.luckLottery[key]
        }
      }
      return {
        ...context.luckLottery,
        ...luckLottery
      }
    }
  }),
  reDrawActor: pure((context, event) => {
    const arr = []
    const sixBoxGroupid = context.gameConfig.drawGroupid[context.selectedMap].filter(item => item.rank <= 6).map(item => item.groupid)

    for (let key of Object.keys(R.pick(sixBoxGroupid, event.data))) {
      arr.push(send({ type: "DRAW", codeId: event.data[key]?.[0]?.code_id }, { to: key }))
    }
    return arr
  }),
  recordBatchDrawError: assign({
    batchDrawError: context => (context.batchDrawError || 0) + 1
  }),
  resetCouponNum: assign({
    couponNum: () => 0
  }),
  //设置获得的奖品
  setDrawAward: assign({
    award: (context, event) => {
      // let award = context.award || {}
      // award[context.selectedPresentRank] = event.data
      // return award
      return event.data
    },
    couponNum: context => {
      let num = context.couponNum
      if (num > 0) {
        num = num - 1
      }
      return num
    }
  }),
  resetAwardListPage: assign({
    nextAwardListPage: ""
  }),
  //设置返回的中奖列表,
  setWinAward: assign({
    nextAwardListPage: context => {
      let curpage = context.nextAwardListPage || 1
      curpage += 1
      return curpage
    },
    winAward: (context, event) => {
      return event.data
      // const groupid = context.gameConfig.drawGroupid.find(draw => draw.rank == context.selectedPresentRank).groupid
      // if (context.winAward[groupid]) {
      //   context.winAward[groupid] = context.winAward[groupid].concat(event.data)
      // } else {
      //   context.winAward[groupid] = event.data
      // }
      // return context.winAward
    }
  }),
  setPrizeListRank: assign((context, event) => {
    return {
      prizeListRank: event.rank || context.prizeListRank,
      prizeListShowAll: event.showAll
    }
  }),
  //设置奖池列表
  setPrizeList: assign({
    prizeList: (context, event) => event.data
  }),
  //清空奖池列表
  delPrizeList: assign({
    prizeList: ""
  }),
  //购买的时候把物品id存到context
  savePurchaseInfo: assign({
    purchaseInfo: (context, event) => event
  }),
  //购买成功后更新score
  updateTaskScore: assign(context => {
    const curScore = context.taskInfo.total_score,
      pruductScore = context.purchaseInfo.score
    context.taskInfo.total_score = +curScore + +pruductScore

    const map = context.selectedMap
    context.tasks[map] = context.taskInfo
    return {
      taskInfo: context.taskInfo,
      tasks: context.tasks
    }
  }),
  //免费任务成功后更新score
  updateFreeTaskScore: assign(context => {
    const curScore = context.taskInfo.total_score
    context.taskInfo.total_score = +curScore + 1

    const map = context.selectedMap
    context.tasks[map] = context.taskInfo
    return {
      taskInfo: context.taskInfo,
      tasks: context.tasks
    }
  }),
  busyCountTick: assign({
    busyCount: context => (context.busyCount -= 1)
  }),
  placeOrderSuccess: send((context, event) => ({
    type: "PAY",
    data: event.data
  })),
  //数据上报
  report: (context, event) => {
    const result = {}
    if (event.resultInfo) {
      const denyKeys = ["report", "gameConfig", "zoneList", "winAward"]
      Object.keys(event.resultInfo)
        .filter(key => !denyKeys.includes(key))
        .forEach(key => {
          result[key] = event.resultInfo[key]
        })
    }
    userBusiness.reportUserAction({
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      pf: context.pf,
      iformat: event.iformat,
      resultInfo: result
    })
  },
  forwardStartDraw: forwardTo("startDraw"),
  introReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.INTRO
  })),
  getOpenLinkErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.GET_OPENLINK_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  homepageReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.HOMEPAGE
  })),
  clickPresentReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK.BOXES,
    resultInfo: Object.assign(context, event)
  })),
  rulesReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.RULE,
    resultInfo: context
  })),
  luckyDrawErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.LUCKY_DRAW_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  zoneRoleReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.ZONE_ROLE,
    resultInfo: context
  })),
  busyDialogReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.BUSY_DIALOG,
    resultInfo: Object.assign(context, event.data)
  })),
  buyProductReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK[`BUY_PRODUCT_${event.price}`],
    resultInfo: context
  })),
  getAwardListReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.GET_AWARD_LIST,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  getAwardReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.GET_AWARD,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  luckyDrawSuccessReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.LUCKY_DRAW_SUCCESS,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  paySuccessReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.PAY_SUCCESS,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  resetAlertInfo: assign({
    alertInfo: ""
  }),
  setNoChanceAlertInfo: assign({
    alertInfo: context => ({
      msg: context.gameConfig?.tips?.noFreeChance || "您在当前参与活动的大区还没有完成【对战一局】任务，快去完成任务吧~",
      confirmBtn: "去完成",
      jumpUrlOutGame: context.gameConfig?.url?.game
    })
  }),
  setChanceAlertInfo: assign({
    alertInfo: context => ({
      msg: context.gameConfig?.tips?.freeChance || "恭喜你获得一次免费抽奖资格，快去点击宝箱收获奖励吧~",
      confirmBtn: "去抽奖",
      confirmType: "lottery",
      disableClose: true
    })
  }),
  setSelectAlertInfo: assign({
    alertInfo: context => ({
      msg: context.gameConfig?.tips?.selectChance || "去完成一轮对局即可获得免费走第一步的机会",
      miniMsg: context.gameConfig?.tips?.selectChanceMiniTips,
      cancelBtn: "去获得",
      confirmBtn: "直接支付",
      confirmType: "buy"
    })
  }),
  setChanceAndLotteryAlertInfo: assign({
    alertInfo: context => ({
      msg: context.gameConfig?.tips?.selectReceiveChance || "恭喜你获得免费开奖一次的机会",
      confirmBtn: "去开启宝箱",
      confirmType: "lottery",
      disableClose: true
    })
  })
}
